// Layout
import Breadcrumbs from '@/components/ui/Breadcrumbs'

// Next
import { Link } from 'react-router-dom'

// Mantine
import { Button } from '@mantine/core'

// Icons
import { Plus } from '@untitled-ui/icons-react'

import ProductionOrderTable from '@/components/production_orders/ProductionOrderTable'

export default function IndexAssembly() {
    // Breadcrumbs
    const breadcrumbs = [
        {
            label: 'Assemblages',
        },
    ]

    return (
        <div>
            <Breadcrumbs
                breadcrumbs={breadcrumbs}
                rightSection={
                    <Link to="/assembly/create">
                        <Button
                            variant="light"
                            color="dark"
                            leftSection={<Plus width={14} height={14} />}
                        >
                            Créer un assemblage
                        </Button>
                    </Link>
                }
            />

            <ProductionOrderTable />
        </div>
    )
}
